import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <main className="page">
      <h1>ページが見つかりません</h1>
      <p className="lede">指定された URL は存在しません。</p>
      <Link className="text-link" to="/">
        ホームへ戻る
      </Link>
    </main>
  )
}
